import React from "react"
import PropTypes from "prop-types"
import { Header, Footer } from "@bw/layouts"
import { Seo } from "@bw/bits"
import * as Icons from "@bw/icons"
import { createGlobalStyle } from "styled-components"
import styled from "styled-components"
import { Script, useStaticQuery, graphql } from "gatsby"
import { breakpoints } from "../../../theme"
import { allNavsResolver } from "../../../utils/navigationsResolver"
import useWindowHeight from "../../../hooks/useWindowHeight"

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]', {
    offset: 170,
  })
}

const PageColor = createGlobalStyle`
:root {
--page-color: var(--brand-${props => props.color}, var(--brand-p-plus));
--page-color-rgba: var(--brand-${props =>
  props.color}-rgba, var(--brand-p-plus-rgba));
}
`

const Main = styled.main`
  padding-top: 85px;

  @media (min-width: ${breakpoints.medium}px) {
    padding-top: 180px;
  }
`

const BackgroundIcons = styled.div`
  display: none;

  @media (min-width: ${breakpoints.medium}px) {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    overflow: hidden;
    z-index: -1000;
  }
`

const Icon = styled.svg`
  display: block;
  position: absolute;
  left: -380px;
  top: -170px;
  opacity: 0.3;
  color: var(--brand-${props => props.color}, var(--brand-p-plus));
`

const IconSecond = styled.svg`
  display: block;
  position: absolute;
  right: -320px;
  top: 1070px;
  opacity: 0.3;
  color: var(--brand-${props => props.color}, var(--brand-p-plus));
`

const ButtonRDV = styled.a`
  font-family: "Ginto", georgia, serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 0;
  text-decoration: none;
  border: none;
  color: #fff;
  align-items: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-transform: uppercase;
  padding: 1em 1.5em;
  background-color: #8fc31f;
  transition: background-color 0.3s ease-in-out;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;

  &:hover {
    background-color: var(--brand-dark-green);
  }
`

const Layout = ({
  headerNegative,
  children,
  color,
  pageContext,
  fixedHeader,
  orderUrl,
  bookingUrl,
}) => {
  const windowHeight = useWindowHeight()

  const data = useStaticQuery(graphql`
    query MenuQuery {
      burger: allNavBurger(sort: { order: ASC }) {
        nodes {
          page {
            locale
            to: url
            label: title
          }
        }
      }
      footer: allNavPiedDePage(sort: { order: ASC }) {
        nodes {
          page {
            locale
            to: url
            label: title
          }
        }
      }
      shortcuts: allNavRaccourcis(sort: { order: ASC }) {
        nodes {
          page {
            locale
            to: url
            label: title
          }
        }
      }
      settings: globals(handle: { eq: "settings" }) {
        booking_url
      }
    }
  `)

  const { burger, shortcuts, footer } = allNavsResolver({
    burger: data.burger,
    footer: data.footer,
    shortcuts: data.shortcuts,
  })

  if (pageContext?.originalPath === "/") {
    bookingUrl = data.settings.booking_url
  }

  return (
    <>
      <Script id="biskoui">{`
window.biskouiSettings = {
  clientId: "44",
};

(function (d, s) {
  var t = d.getElementsByTagName(s)[0],
  e = d.createElement(s);
  e.async = true;
  e.src = "https://static.biskoui.ch/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");
`}</Script>
      <PageColor color={color} />
      <Seo />
      <Icons.Symbols />
      <Header
        menu={shortcuts}
        menuLayer={burger}
        negative={headerNegative}
        fixedHeader={fixedHeader}
        orderUrl={orderUrl}
      />

      <Main>{children}</Main>
      <Footer
        copyright="pharmacieplus"
        logos={pageContext?.originalPath === "/" ? "homepage" : "standard"}
        menu={footer}
      />
      <BackgroundIcons style={{ height: `${windowHeight}px` }}>
        <Icon width="1092" height="1092" color={color}>
          <use xlinkHref="#plus" />
        </Icon>
        <IconSecond width="900" height="900" color={color}>
          <use xlinkHref="#plus" />
        </IconSecond>
      </BackgroundIcons>
      {bookingUrl && (
        <ButtonRDV href={bookingUrl} target="_blank" rel="noreferrer">
          <Icons.Calendar />
          <span>RDV en ligne</span>
        </ButtonRDV>
      )}
    </>
  )
}

export { Layout }

Layout.propTypes = {
  fixedHeader: PropTypes.bool,
  color: PropTypes.oneOf([
    "art-de-vie",
    "love",
    "bebe",
    "urgence",
    "peau",
    "peach",
    "p-plus",
    "soleil-d-hiver",
    "mentalo",
    "nausee",
    "eau-douce",
    "zen",
  ]),
}

Layout.defaultProps = {
  fixedHeader: true,
}
